import { render } from "./InConsoleArticle.vue.ts?vue&type=template&id=f8282b50&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleArticle.vue?vue&type=template&id=f8282b50&scoped=true&ts=true"
import script from "./InConsoleArticle.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./InConsoleArticle.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleArticle.vue?vue&type=script&setup=true&lang=ts"

import "./InConsoleArticle.vue.scss?vue&type=style&index=0&id=f8282b50&lang=scss&scoped=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleArticle.vue?vue&type=style&index=0&id=f8282b50&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8282b50"],['__file',"src/apps/merchant3/components/in-console/articles/InConsoleArticle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8282b50"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8282b50', __exports__)) {
    api.reload('f8282b50', __exports__)
  }
  
  module.hot.accept("./InConsoleArticle.vue.ts?vue&type=template&id=f8282b50&scoped=true&ts=true!=!../../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./InConsoleArticle.vue?vue&type=template&id=f8282b50&scoped=true&ts=true", () => {
    api.rerender('f8282b50', render)
  })

}


export default __exports__